import store from '@/store'

const defaultAppInfos = {
  icon: 'km-icon-apps',
}

export default function getAppInfos(appName) {
  const processes = store.getters.select({ appName }).processes
  if (!processes.length) return defaultAppInfos

  const axmOptions = processes[0].axm_options
  return {
    icon: axmOptions.isModule ? 'km-icon-module' : 'km-icon-apps',
  }
}
